import type { IDividerProps } from './Divider'

import { styled } from '@linaria/react'
import { DividerFluid } from './Divider.h'

export const DividerLine = styled.div<IDividerProps>`
  background: ${({ background }) =>
    background ? `var(${background})` : `none`};
  width: ${({ fluid, width }) =>
    fluid === DividerFluid.Both || fluid === DividerFluid.Horizontal
      ? width || '100%'
      : width
        ? width
        : 'auto'};
  max-width: 100%;
  height: ${({ fluid, height }) =>
    fluid === DividerFluid.Both || fluid === DividerFluid.Vertical
      ? height || 'inherit'
      : height
        ? height
        : 'auto'};
  display: block;
  border: none;
`
